var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrometheusinline = function SvgPrometheusinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F55C3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 51c-4.071 0-7.372-2.75-7.372-6.143h14.745C35.373 48.25 32.072 51 28 51Zm12.178-8.177H15.822v-4.467h24.356v4.467Zm-.088-6.766H15.891c-.08-.094-.163-.186-.24-.281-2.494-3.062-3.08-4.66-3.651-6.289-.01-.054 3.023.627 5.174 1.116 0 0 1.106.259 2.724.557-1.553-1.841-2.476-4.182-2.476-6.575 0-5.253 3.984-9.844 2.547-13.554 1.399.115 2.895 2.986 2.996 7.474 1.487-2.078 2.11-5.874 2.11-8.201 0-2.41 1.57-5.208 3.14-5.304-1.4 2.333.362 4.333 1.929 9.295.588 1.864.513 5 .966 6.99.15-4.132.853-10.16 3.444-12.24-1.143 2.62.17 5.9 1.067 7.476 1.448 2.543 2.326 4.47 2.326 8.115 0 2.444-.892 4.745-2.397 6.543a59.133 59.133 0 0 0 2.893-.617L44 29.465s-.807 3.358-3.91 6.592Z",
    fill: "#fff"
  })));
};
export default SvgPrometheusinline;